import { apiClient } from './apiClient';

class QuestionnaireService {
    constructor() {
        this.BASE = '/provider-questionnaires';
    }

    async getTemplate() {
        try {
            const response = await apiClient.get(`${this.BASE}/template`);
            return response?.data ?? response;
        } catch (err) {
            console.error('Error fetching questionnaire template', err);
            throw err;
        }
    }

    async updateTemplate(template) {
        try {
            const response = await apiClient.put(`${this.BASE}/template`, template);
            return response;
        } catch (err) {
            console.error('Error updating questionnaire template', err);
            throw err;
        }
    }

    // Create new questionnaire for a provider
    async createQuestionnaire(providerId, questionnaireType = 'periodic_compliance') {
        if (!providerId) throw new Error('providerId is required');
        try {
            const response = await apiClient.post(this.BASE, { providerId, questionnaireType });
            return response;
        } catch (err) {
            console.error('Error creating questionnaire', err);
            throw err;
        }
    }

    async getQuestionnaire(id) {
        try {
            const response = await apiClient.get(`${this.BASE}/${id}`);
            return response;
        } catch (err) {
            console.error('Error fetching questionnaire', err);
            throw err;
        }
    }

    async submitQuestionnaire(id, responses) {
        try {
            const response = await apiClient.post(`${this.BASE}/${id}/submit`, { responses });
            return response;
        } catch (err) {
            console.error('Error submitting questionnaire', err);
            throw err;
        }
    }

    // Get provider compliance profile
    async getProviderCompliance(providerId) {
        if (!providerId) throw new Error('providerId is required');
        try {
            // Changed to GET to match backend cleanup
            const response = await apiClient.get(`${this.BASE}/providers/${providerId}/compliance`);
            return response;
        } catch (err) {
            console.error('Error fetching provider compliance', err);
            throw err;
        }
    }

    // Get all questionnaires for a provider
    async getProviderQuestionnaires(providerId) {
        try {
            const response = await apiClient.get(`${this.BASE}/providers/${providerId}`);
            return response;
        } catch (err) {
            console.error('Error fetching provider questionnaires', err);
            throw err;
        }
    }

    async getComplianceDashboard(params) {
        try {
            const response = await apiClient.get(`${this.BASE}/compliance-dashboard`, { params });
            return response;
        } catch (err) {
            console.error('Error fetching compliance dashboard', err);
            throw err;
        }
    }

    async sendQuestionnaireLink(providerId, questionnaireId, channel) {
        try {
            const response = await apiClient.post(`${this.BASE}/send-link`, { providerId, questionnaireId, channel });
            return response;
        } catch (err) {
            console.error('Error sending questionnaire link', err);
            throw err;
        }
    }

    async getInventoryAlerts() {
        try {
            const response = await apiClient.get(`${this.BASE}/inventory-alerts`);
            return response;
        } catch (error) {
            console.error('Error fetching inventory alerts:', error);
            throw error;
        }
    }
}

export const questionnaireService = new QuestionnaireService();
export default questionnaireService;